import gql from 'graphql-tag';

export const CreateParticipantTask = gql`
  mutation CreateParticipantTask(
    $organizationId: ID!
    $participantId: ID!
    $request: CreateParticipantTaskRequest!
  ) {
    createParticipantTask(
      organizationId: $organizationId
      participantId: $participantId
      request: $request
    ) {
      id
      participantId
      name
      labels {
        id
        name
        color
      }
      assignees {
        id
        name
        email
        title
      }
      dueDate
      requiresDueDate
      completedAt
      createdAt
      updatedAt
      status
    }
  }
`;
